import {EntityApiService, ApiClientService} from '@dofleini/security';

class NomenclaturesActivitiesApiService extends EntityApiService {

    getOneActivity = ({id}) => ApiClientService.get(this.getPath(`/${id}`));

}

export default new NomenclaturesActivitiesApiService('/ms-core/api/activities');
